import { FC } from 'react'

import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import RouterLink from '@components/UI/RouterLink/RouterLink.styled'
import { ALL } from '@constants'
import { useCampaignIdFromRoute } from '@hooks/useCampaignIdFromRoute'
import { useLocationSearch } from '@hooks/useLocationSearch'
import { usePreapprovalAmountPercentage } from '@hooks/usePreapprovalAmountPercentage'
import { IApplicationState } from '@store'
import { selectCurrentDeclinedFilter } from '@store/router'
import { selectFilteredDeclinedSubmissionsLinkFilters } from '@store/submissions'
import Theme from '@theme'
import { Container, Text } from '@tribegroup'
import { objectToQueryString } from '@utils'
import { DeclinedFilter } from './Filters.styled'

const InboxTopPanelDeclinedFilters: FC = () => {
  const campaignId = useCampaignIdFromRoute() as number
  const currentDeclineFilter = useSelector((state: IApplicationState) =>
    selectCurrentDeclinedFilter(state),
  )
  const declinedFilters = useSelector((state: IApplicationState) =>
    selectFilteredDeclinedSubmissionsLinkFilters(
      state,
      campaignId,
      currentDeclineFilter === 'all' ? undefined : currentDeclineFilter,
    ),
  )

  const percentage = usePreapprovalAmountPercentage()
  const currentSearch = useLocationSearch()

  const allDeclinedFilters = [ALL, ...declinedFilters]

  return (
    <Container bottomOuterSpacing={1.25}>
      {allDeclinedFilters.map((filter: string) => (
        <RouterLink
          key={filter}
          to={{
            search: objectToQueryString({
              ...currentSearch,
              declined_filter: filter === ALL ? undefined : filter,
            }),
          }}
        >
          <DeclinedFilter active={currentDeclineFilter === filter}>
            <Text color={Theme.grey800Color}>
              <FormattedMessage
                id={`inbox.cardlist.declined.filter.${filter}`}
                values={{ percentage }}
              />
            </Text>
          </DeclinedFilter>
        </RouterLink>
      ))}
    </Container>
  )
}

export default InboxTopPanelDeclinedFilters
